export default "__VITE_ASSET__BJpjxTzP__"